import type { FaireProductEntity } from "../../entity_types/product";

export const p_zs5b2st3hr: FaireProductEntity = {
  token: "p_zs5b2st3hr",
  type: "product",
  name: "Onyx T-Rex Dinosaur",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl: "https://cdn.faire.com/fastly/61c21c820c154c305b14b0009381e05ccb99dd1a1252fc09bfd84b2a2d18c5d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b57d1cb2d963a959db3d8cebf1dd967c8b3d4b38401ac9c27a22db71930a433.jpeg"
  ],
  priceDollars: 16.63,
  description: "Hand made in Pakistan with natural onyx, this Dinosaur is approx. 4\".  Ideal crystal for the blooming Spring season. ",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:15.384Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
